import { jsx as _jsx } from "react/jsx-runtime";
import { MessageBox, MessageBoxVariant } from "../../../../components/MessageBox/MessageBox";
import { useTranslations } from "../../../../providers/useTranslations";
export const PhoneVerificationMessage = ({ isVisible, className }) => {
    const { __ } = useTranslations();
    return (_jsx(MessageBox, { isVisible: isVisible, variant: MessageBoxVariant.message, isScrollable: false, "data-testid": "phoneValidatedViaSmsAlert", hideIcon: true, className: className, children: __("auth.registration.phone_verified_via_sms") }));
};
//# sourceMappingURL=PhoneVerificationMessage.js.map